import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServiceValuationFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServiceValuationFormStepOne from "./ServiceValuationFormSteps/ServiceValuationFormStepOne";
import ServiceValuationFormStepTwo from "./ServiceValuationFormSteps/ServiceValuationFormStepTwo";
import ServiceValuationFormStepThree from "./ServiceValuationFormSteps/ServiceValuationFormStepThree";
import ServiceValuationFormStepFour from "./ServiceValuationFormSteps/ServiceValuationFormStepFour";

const ServiceValuationForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedValuationParts, setSelectedValuationParts] = useState(_initialValues?.valuationParts || []);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues,
        billingType:{value:_initialValues?.billingType||null}
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
        billingType:{value:_initialValues?.billingType||null}
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val, selectedValuationParts, selectedServices }, props)}
      validate={(val) => onValidate({ ...val, selectedValuationParts, selectedServices }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServicePartForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceValuationFormStepOne {...formProps} {...props} setSelectedServices={setSelectedServices} selectedServices={selectedServices} />
              <ServiceValuationFormStepTwo {...formProps} {...props} setSelectedValuationParts={setSelectedValuationParts} selectedValuationParts={selectedValuationParts} />
              <ServiceValuationFormStepThree {...formProps} {...props}/>
              <ServiceValuationFormStepFour {...formProps} {...props}/>
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceValuationForm;
